import { Grid } from "@mui/material";
import { DatePickerField, DropDown } from "components/UI";
import React, { useEffect, useState, Fragment } from "react";
import ButtonAction from "../ButtonAction";
import { FORM_DEFAULT_MONTH } from "pages/Report/constants/constants";
import {
  useReportCommonGetCountryListQuery,
  useReportCommonGetRPackageOwnerQuery,
  useReportCommonGetRPackageTypeCategoryQuery,
  useReportCommonGetWarehouseListQuery,
  useReportCommonRPackageCategoryQuery,
  useGetDetailDataTypeListQuery,
  useExcelDownloadOnlineJavaMutation,
} from "shared/services/report";

import { responseErrors } from "utils";
import { useLoadingContext } from "shared/contexts/LoadingContext";
import { waitAndDownloadExcel } from "shared/services/common-dowload/download-helper-service";
import { useSelector } from "react-redux";
import { COMMON_ENUM } from "shared/constants";

export default function MonthlyForecastReport(props) {
  const [form, setForm] = useState(FORM_DEFAULT_MONTH);
  const userInfo = useSelector(state => state.auth.user);

  const { data: rPkgOwnerList } = useReportCommonGetRPackageOwnerQuery();
  const { data: rPkgCategoryList } = useReportCommonRPackageCategoryQuery();
  const { data: rPkgTypeList } = useReportCommonGetRPackageTypeCategoryQuery(
    form?.rPkgTypeOwner,
    form?.rPkgTypeCategory
  );

  const { data: countryList } = useReportCommonGetCountryListQuery(userInfo.country, userInfo.companyAbbr);
  const { data: warehouseList } = useReportCommonGetWarehouseListQuery(form?.countryId, userInfo.companyAbbr);
  const { data: dataTypeList } = useGetDetailDataTypeListQuery();

  const [disabledSubmitBtn, setDisabledSubmitBtn] = useState(false);

  const generateReport = useExcelDownloadOnlineJavaMutation();
  const { startLoading, stopLoading } = useLoadingContext();
  const handleDownload = async () => {
    try {
      props.setMsgError([]);
      props.setMsgAlert([]);
      const body = {
        month: form?.month,
        country: form?.countryId,
        warehouse: form?.warehouseId,
        rPackageOwner: form?.rPkgTypeOwner,
        rPackageCategory: form?.rPkgTypeCategory,
        rPackageType: form?.rPkgType,
        dataType: form?.dataTypeId,
        userId: userInfo.userName,
        displayName: userInfo.displayName,
        dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
        userCompAbbr: userInfo.companyAbbr,
      };
      const pathReport = "generate-monthly-forecast-report";
      startLoading();
      const response = await generateReport(body, pathReport);
      waitAndDownloadExcel(60, response?.data, props.setMsgError, stopLoading);
      setDisabledSubmitBtn(false);
      return;
    } catch (error) {
      console.error(error);
      const msgError = responseErrors(error);
      props.setMsgError(msgError);
      // }
      setDisabledSubmitBtn(false);
      stopLoading();
    }
  };

  useEffect(() => {
    document.getElementById("select-country").focus();
  }, []);

  return (
    <Fragment>
      <Grid container sx={{ alignItems: "center" }}>
        <Grid item xs={5} style={{ display: "flex", margin: "4px 0" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>*Report : </strong>
          <DropDown
            id="select-report"
            fullWidth
            required
            defaultValue=""
            placeholder="<Select>"
            menu={[{ key: "1", value: "Monthly Forecast Report" }]}
            value={form?.reportId}
            disabled
          />
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={5} style={{ display: "flex", margin: "4px 0" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>*Country : </strong>
          <DropDown
            id="select-country"
            fullWidth
            required
            value={form?.countryId}
            defaultValue=""
            placeholder="<Select>"
            menu={countryList?.map(val => ({
              key: val.cd,
              value: val.value,
            }))}
            onChange={async e => {
              setForm(old => ({
                ...old,
                countryId: e.target.value,
                warehouseId: "",
              }));
            }}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex", margin: "4px 0" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>*Warehouse : </strong>
          <DropDown
            id="select-warehouse"
            fullWidth
            required
            value={form?.warehouseId}
            defaultValue=""
            placeholder="<Select>"
            menu={warehouseList?.map(val => ({
              key: val.label,
              value: val.label,
            }))}
            onChange={e =>
              setForm(old => ({
                ...old,
                warehouseId: e.target.value,
              }))
            }
            disabled={!warehouseList?.length}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex", margin: "4px 0" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>*Month : </strong>
          <DatePickerField
            views={["month", "year"]}
            format="MM/YYYY"
            mask="MM/YYYY"
            fullWidth={true}
            value={form?.month}
            onChange={e =>
              setForm(old => ({
                ...old,
                month: e,
              }))
            }
            required
          />
        </Grid>
        <Grid item xs={1}>
          (MM/YYYY)
        </Grid>
        <Grid item xs={5} style={{ display: "flex", margin: "4px 0" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>*Data Type : </strong>
          <DropDown
            id="select-data-type"
            fullWidth
            required
            value={form?.dataTypeId}
            defaultValue=""
            placeholder="<Select>"
            menu={dataTypeList?.map(val => ({
              key: val.cd,
              value: val.value,
            }))}
            onChange={e =>
              setForm(old => ({
                ...old,
                dataTypeId: e.target.value,
              }))
            }
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex", margin: "4px 0" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>*R-Package Owner : </strong>
          <DropDown
            id="select-rpackage-owner"
            fullWidth
            required
            value={form?.rPkgTypeOwner}
            defaultValue=""
            placeholder="<Select>"
            menu={rPkgOwnerList?.map(val => ({
              key: val.rPkgOwnerCompAbbr,
              value: val.rPkgOwnerCompAbbr,
            }))}
            onChange={e =>
              setForm(old => ({
                ...old,
                rPkgTypeOwner: e.target.value,
                rPkgTypeCategory: "",
                rPkgType: "",
              }))
            }
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex", margin: "4px 0" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>*R-Package Category : </strong>
          <DropDown
            id="select-rpackage-category"
            fullWidth
            required
            value={form?.rPkgTypeCategory}
            defaultValue=""
            placeholder="<Select>"
            menu={rPkgCategoryList?.map(val => ({
              key: val.cd,
              value: val.value,
            }))}
            onChange={e =>
              setForm(old => ({
                ...old,
                rPkgTypeCategory: e.target.value,
                rPkgType: "",
              }))
            }
            disabled={!form.rPkgTypeOwner}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex", margin: "4px 0" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>R-Package Type : </strong>
          <DropDown
            id="select-rpackage-type"
            fullWidth
            value={form?.rPkgType}
            defaultValue=""
            placeholder="<All>"
            menu={rPkgTypeList?.map(val => ({
              key: val.rPkgType,
              value: val.rPkgType,
            }))}
            onChange={e =>
              setForm(old => ({
                ...old,
                rPkgType: e.target.value,
              }))
            }
            disabled={!form.rPkgTypeCategory}
          />
        </Grid>
      </Grid>
      <ButtonAction
        handleDownload={handleDownload}
        setFrom={setForm}
        defaultFrom={FORM_DEFAULT_MONTH}
        disabled={disabledSubmitBtn}
        setDisabled={setDisabledSubmitBtn}
        clearMsg={() => {
          props.setMsgAlert([]);
          props.setMsgError([]);
        }}
        firstField={"select-country"}
      />
    </Fragment>
  );
}
